import { Box, useTheme, useMediaQuery } from "@mui/material";
import Form from "./Form";
import PageHeader from "components/PageHeader";
import PageFooter from "components/PageFooter";
import { LAYOUT_HEIGHT } from 'state/constants';

const LoginPage = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (    
    <Box>
      <PageHeader/>    

      <Box 
        aria-label="LoginPage"      
        display="flex" 
        justifyContent="center"
        alignItems="center"
        minHeight={LAYOUT_HEIGHT}
      >
        <Box
          width={isDesktop ? "50%" : "92%"}
          sx={{
            position: "relative",
            borderRadius: "1rem",
            padding: "1px", 
            background: `linear-gradient(
              150deg, 
              ${theme.palette.primary.main},
              ${theme.palette.primary.light},
              ${theme.palette.primary.main}
            )`,
            backgroundSize: "200% 200%",
            animation: "shine 6s linear infinite",
            "@keyframes shine": {
              "0%": { backgroundPosition: "0% 50%" },
              "100%": { backgroundPosition: "200% 50%" },
            },
          }}
        >
          <Box          
            p={theme.spacing(4)}          
            borderRadius="1rem"
            backgroundColor={theme.palette.background.alt}       
          >
            <Form />
          </Box>
        </Box>      
      </Box>

      <PageFooter/>
    </Box>
  );
};

export default LoginPage;
